import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="review-intro"]' },
  { target: '[data-tour="review-filters"]' },
  { target: '[data-tour="review-list"]', spotlightChildCount: 3 },
  { target: '[data-tour="review-detail"]' }
];

export const FAMILY_REVIEW_TOUR_STEPS: TourStep[] = buildTourSteps('familyReview', STEP_DEFS);

export const FAMILY_REVIEW_TOUR_STORAGE_KEY = 'wetree-family-review-tour-completed';

export function resolveFamilyReviewTourSteps(steps: TourStep[], hasPendingItems: boolean): TourStep[] {
  if (hasPendingItems) {
    return steps;
  }
  return steps.filter(
    (step) => step.target !== '[data-tour="review-list"]' && step.target !== '[data-tour="review-detail"]'
  );
}
